import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.large-image-video-tile',
        fullscreenIcon: '.image-video-tile__fullscreen-icon',
        carouselHero: '.carousel-hero',
        carouselHeroSlides: '.carousel-hero__slides',
        carouselHeroSlide: '.carousel-hero__slide',
        lighthouseContainer: '.carousel-hero__lighthouse-container',
        lighthouseImageVideoTileContainer: '.large-image-video-tile__lighthouse-container',
        videoLighthouse: '.video-lighthouse',
        videoCloseButton: '.video__close-button',
        video: '.video__video',
        videoMobile: '.video__video-mobile',
        videoWrapper: '.video__wrapper',
        controls: '.video__controls',
        closeButton: '.video__close-button',
        duoItem: '.large-image-video-tile__duo-item',
        singleItem: '.large-image-video-tile__single',
        trippleItem: '.large-image-video-tile__tripple',
        videoJS: '.video-js',

    },
    classNames: {
        videoHide: 'video__video--hidden',
        videoWrapperSmall: 'video__wrapper--small',
        bodyNoScroll: 'body--no-scroll',
        videoControlsHidden: 'video__controls--hidden',
    },
    dataAttributes: {
        slickIndex: 'slick-index',
        fullscreenIndex: 'index',
        itemIndex: 'item-index',
        autoplay: 'autoplay',
    },
   
};

class LargeImageVideoTile {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this._index = 0;
        this._currentTarget = null;
    }

    init() {
        // listen for initialization event
        this._elements = this._getDomElements();
        this._addEventListeners();

        this._elements.$videoWrapper.addClass(config.classNames.videoWrapperSmall);
        this._elements.$video.addClass(config.classNames.videoHide);
        this._elements.$videoMobile.addClass(config.classNames.videoHide);
        this._fullSizedVideo();
        this._closeVideo();      
    }

    _getDomElements() {
        return {
          $body: $('body'),
          $html: $('html'),
          $root: this._$rootElement.find(config.selectors.root),
          $fullscreenIcon: this._$rootElement.find(config.selectors.fullscreenIcon),
          $carouselHero: this._$rootElement.find(config.selectors.carouselHero),
          $carouselHeroSlides: this._$rootElement.find(config.selectors.carouselHeroSlides),
          $lighthouseContainer: this._$rootElement.find(config.selectors.lighthouseContainer),
          $videoLighthouse: this._$rootElement.find(config.selectors.videoLighthouse),
          $videoCloseButton: this._$rootElement.find(config.selectors.videoCloseButton),
          $video: this._$rootElement.find(config.selectors.video),
          $videoJS: this._$rootElement.find(config.selectors.videoJS),
          $videoMobile: this._$rootElement.find(config.selectors.videoMobile),
          $videoWrapper: this._$rootElement.find(config.selectors.videoWrapper),
          $controls: this._$rootElement.find(config.selectors.controls),
          $closeButton: this._$rootElement.find(config.selectors.closeButton),
          $duoItem: this._$rootElement.find(config.selectors.duoItem),
          $singleItem: this._$rootElement.find(config.selectors.singleItem),
        };
    }

    _addEventListeners() {
        const _this = this;
    }

    _fullSizedVideo() {
        const _this = this;
        this._elements.$fullscreenIcon.on('click keydown', e => {

            let closestCarouselSlide, slideIndex, closestCarouselHero, activeFullscreenElement;

            if($(e.target).closest(config.selectors.trippleItem)[0]){
                 closestCarouselSlide = $(e.target).closest(config.selectors.carouselHeroSlide);

                 const videoSettings = $(closestCarouselSlide).find(config.selectors.videoJS)[0]; 

                 _this._currentTarget =$(e.target).closest(config.selectors.carouselHeroSlide);
                 slideIndex = $(closestCarouselSlide).data(config.dataAttributes.slickIndex);
                 closestCarouselHero = $(e.target).closest(config.selectors.carouselHero);
                 activeFullscreenElement = $(closestCarouselHero).find(`${config.selectors.lighthouseContainer}[data-index="${slideIndex}"]`);
    
                 $(activeFullscreenElement).find(config.selectors.video).removeClass(config.classNames.videoHide);
                 $(activeFullscreenElement).find(config.selectors.videoMobile).removeClass(config.classNames.videoHide);
                 $(activeFullscreenElement).find(config.selectors.videoWrapper).removeClass(config.classNames.videoWrapperSmall);
                 $(activeFullscreenElement).find(config.selectors.controls).removeClass(config.classNames.videoControlsHidden);
                 $(activeFullscreenElement).find(config.selectors.videoLighthouse)[0].style.opacity = '1';
                 $(activeFullscreenElement).find(config.selectors.videoLighthouse)[0].style.visibility = 'visible';
                 $(activeFullscreenElement).find(config.selectors.video)[0].style.opacity = '1';
                 $(activeFullscreenElement).find(config.selectors.video)[0].style.visibility = 'visible';
                 this._elements.$html.addClass(config.classNames.bodyNoScroll);
                
                 videoSettings.player.pause();

                 $(activeFullscreenElement).find(config.selectors.video)[0].player.currentTime(videoSettings.player.currentTime());
                 $(activeFullscreenElement).find(config.selectors.video)[0].player.play();
                
            }
        });
    }

    _closeVideo() {
        const _this = this;
        this._elements.$closeButton.on('click keydown', (e) => {
            let closestCarouselSlide;
            if($(e.target).closest(config.selectors.trippleItem)[0]){
                const parentVideoContainer = $(_this._currentTarget).find('.video-js')
               
                closestCarouselSlide = $(e.target).closest(config.selectors.lighthouseContainer)
                const videoSettings = $(closestCarouselSlide).find(config.selectors.video)[0];
    
                $(closestCarouselSlide).find(config.selectors.video).addClass(config.classNames.videoHide)
                $(closestCarouselSlide).find(config.selectors.videoMobile).addClass(config.classNames.videoHide)
                $(closestCarouselSlide).find(config.selectors.videoWrapper).addClass(config.classNames.videoWrapperSmall)
                $(closestCarouselSlide).find(config.selectors.controls).addClass(config.classNames.videoControlsHidden)
                $(closestCarouselSlide).find(config.selectors.videoLighthouse)[0].style.opacity = '0'
                $(closestCarouselSlide).find(config.selectors.videoLighthouse)[0].style.visibility = 'hidden'
                $(closestCarouselSlide).find(config.selectors.video)[0].style.opacity = '0';
                $(closestCarouselSlide).find(config.selectors.video)[0].style.visibility = 'hidden';
                this._elements.$html.removeClass(config.classNames.bodyNoScroll);
                videoSettings.player.pause();

                if(videoSettings.player.paused()) {
                    parentVideoContainer[0].player.currentTime(videoSettings.player.currentTime())
                    parentVideoContainer[0].player.play()
                }
            
            }
          
        });
    }
}


moduleRegistry.registerModule('LargeImageVideoTile', LargeImageVideoTile);
moduleRegistry.autoApplyModule('LargeImageVideoTile', config.selectors.root);